import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import sessionStore from '../stores/SessionStore';

const PilotProtectedRoute: React.FC<{ redirectPath?: string }> = observer(({ redirectPath = '/' }) => {
  const { user } = sessionStore;

  const isPilot = true; // sessionStore.isAuthenticated && user?.permissions?.includes('pilot');

  if (!isPilot) {
    return <Navigate replace to={redirectPath} />;
  }

  return <Outlet />;
});

export default PilotProtectedRoute;
